import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'nrepo:content-scale';
const DEFAULT_SCALE = 100;
const MIN_SCALE = 80;
const MAX_SCALE = 200;
const BASE_PX = 14;

function getInitialScale(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const val = parseInt(stored, 10);
      if (val >= MIN_SCALE && val <= MAX_SCALE) return val;
    }
  } catch { /* ignore */ }
  return DEFAULT_SCALE;
}

export function useFontSize() {
  const [scale, setScaleState] = useState<number>(getInitialScale);

  useEffect(() => {
    document.documentElement.style.fontSize = `${(BASE_PX * scale) / 100}px`;
    try { localStorage.setItem(STORAGE_KEY, String(scale)); } catch { /* ignore */ }
  }, [scale]);

  const setScale = useCallback((s: number) => {
    setScaleState(Math.max(MIN_SCALE, Math.min(MAX_SCALE, s)));
  }, []);

  const resetScale = useCallback(() => setScaleState(DEFAULT_SCALE), []);

  return { scale, setScale, resetScale, MIN_SCALE, MAX_SCALE, DEFAULT_SCALE };
}
